import Vue from 'vue';
function formModel() {
    return {
        documents: [],
    }
}


const state = {
    model: formModel(),
    onlyRead: true,
};

const mutations = {

    addDoc(state, payload) {
		state.model.documents.push(
			{
                "id": null,
                "file_id": payload.file_id,
                "fileNameHash": payload.fileNameHash,
                "document_type_id": null,
                "section_id" : payload.section_id,
                "isActive": true,
                "fileName": payload.fileName,
                "description" : null
			}
		);
	},


	removeDocument(state, payload) {
		let index = state.model.documents.indexOf(payload);
		state.model.documents.splice(index, 1);
	},

};

const actions = {


};

const getters = {
    requestForm: state => state.model,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};

